module.exports = __webpack_public_path__ + "img/map_sample.a33f00b3.png";